import { Component } from '@angular/core'

@Component({
  selector: 'se-po-household-setup-feature-parent-guardian-info-docs',
  templateUrl: './parent-guardian-info-docs.component.html',
  styleUrls: ['./parent-guardian-info-docs.component.scss'],
  standalone: false,
})
export class ParentGuardianInfoDocsComponent { }
